module.exports = __webpack_public_path__ + "static/react-be3668f7ecbe460befcb22b9a8a87792.png";